import Input from 'tailwind-components/Input/Input';
import React from 'react';
import FormWithEditButton from 'tailwind-components/FormWithEditButton/FormWithEditButton';
import propTypes from 'prop-types';
import { useSelector } from 'react-redux';
import Card from 'tailwind-components/Card/Card';
import { thousandsSeparator } from 'helpers/strings';
import dateFactory from 'helpers/factory/dateFactory';

export default function EOCoverage({ setModalText, setIsOpenPrimaryModal }) {
  const user = useSelector(state => state.user.zohoData);

  return (
    <Card
      title='E&O Coverage'
      withSeparator
      separatorVariant='dashed'
      className='min-w-0 lg:col-span-2'
    >
      <FormWithEditButton
        buttonText='Edit'
        onClick={() => {
          setModalText('E&O Coverage');
          setIsOpenPrimaryModal(true);
        }}
      >
        <div className='grid min-w-0 grid-cols-1 gap-4 md:grid-cols-2 xl:grid-cols-3'>
          <Input
            label='E&O Expiration Date'
            value={
              user.E_O_Expiration_Date
                ? dateFactory(user.E_O_Expiration_Date)
                : ''
            }
            placeholder='-'
            disabled
            compact
            wrapValue
            fullWidthLabel
            className='min-w-0'
            labelClassName='text-primary'
          />
          <Input
            label='E&O Coverage Carrier'
            value={user.E_O_Coverage_Carrier || ''}
            placeholder='-'
            disabled
            compact
            wrapValue
            fullWidthLabel
            className='min-w-0'
            labelClassName='text-primary'
          />
          <Input
            label='Policy Number'
            value={user.Policy_Number || ''}
            placeholder='-'
            disabled
            compact
            wrapValue
            fullWidthLabel
            className='min-w-0'
            labelClassName='text-primary'
          />
          <Input
            label='Amount Per Claim'
            value={`$ ${
              user.Amount_Per_Claim
                ? thousandsSeparator(user.Amount_Per_Claim)
                : '-'
            }`}
            placeholder='-'
            disabled
            compact
            wrapValue
            fullWidthLabel
            className='min-w-0'
            labelClassName='text-primary'
          />
          <Input
            label='Amount Aggregate'
            value={`$ ${
              user.Amount_Aggregate
                ? thousandsSeparator(user.Amount_Aggregate)
                : '-'
            }`}
            placeholder='-'
            disabled
            compact
            wrapValue
            fullWidthLabel
            className='min-w-0'
            labelClassName='text-primary'
          />
        </div>
      </FormWithEditButton>
    </Card>
  );
}

EOCoverage.propTypes = {
  setModalText: propTypes.func,
  setIsOpenPrimaryModal: propTypes.func
};
